import { AtriumApi } from "../../config/api";
import axios from "axios";

// initial state
const state = {
  loading: false,
  error: false,
  groupCorrelation: null,
  correlation: null,
  correlationDetail: null,
  contentUrl: "",
  strings: {}
};

const getters = {
  atriumApi(state) {
    return AtriumApi;
  },
  contentUrl() {
    return `${AtriumApi}content`;
  },
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  },
  correlation(state) {
    return state.correlation;
  },
  correlationDetail(state) {
    return state.correlationDetail;
  },
  groupCorrelation(state) {
    return state.groupCorrelation;
  },
  strings(state) {
    return state.strings;
  }
};

// mutations
const mutations = {
  setStrings(state, payload) {
    state.strings = payload;
  },
  selectedGroup(state, payload) {
    state.selectedGroup = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  clearLoading(state) {
    state.loading = false;
  },
  setError(state, payload) {
    state.error = payload;
  },
  clearError(state) {
    state.error = false;
  },
  setCorrelation(state, payload) {
    state.correlation = payload;
  },
  setCorrelationDetail(state, payload) {
    state.correlationDetail = payload;
  },
  setPoisInActiveGroup(state, payload) {
    state.poisInActiveGroup = payload;
  },
  setAddComment(state, payload) {
    const corr = state.poisInActiveGroup.find(c => c.id == payload.id);
    if (corr) {
      corr.comments = [...corr.comments, payload.comment];
    }
  },
  setOnSiteTechnicianData(state, payload) {
    const corr = state.poisInActiveGroup.find(c => c.id == payload.id);
    if (corr) {
      corr.technicianData.onSiteTimes = [...payload.data];
    }
  },
  setPauseTechnicianData(state, payload) {
    const corr = state.poisInActiveGroup.find(c => c.id == payload.id);
    if (corr) {
      corr.technicianData.paused = payload.data;
    }
  },
  setUpdateTechnicianData(state, payload) {
    const corr = state.poisInActiveGroup.find(c => c.id == payload.id);
    if (corr) {
      const oldData = { ...corr.technicianData };
      corr.technicianData = { ...oldData, ...payload.technicianData };
      const refresh = state.poisInActiveGroup.find(c => c.id == -1);
    }
  },
  setTechnicianData(state, payload) {
    const poi = state.poisInActiveGroup.find(c => c.id == payload.id);
    if (poi) {
      const newData = { ...poi.technicianData, ...payload.technicianData };
      poi.technicianData = newData;
    }
  },
  updateLeaks(state, payload) {
    const poi = state.poisInActiveGroup.find(c => c.id == payload.id);
    if (poi) {
      // const exisitingLeaks = [...poi.technicianData.leaks];
      poi.technicianData.leaks = [...payload.leaks];
    }
  },
  removeLeak(state, payload) {
    const poi = state.poisInActiveGroup.find(c => c.id == payload.id);
    if (poi) {
      poi.technicianData.leaks = [...payload.leaks];
    }
  },
  // setSelectedPoiId(state, id) {
  //   state.selectedPoiId = id;
  // },
  completePoi(state, id) {
    const pois = state.poisInActiveGroup.filter(c => c.id !== id);
    state.poisInActiveGroup = pois;
  }
};

// actions
const actions = {
  getStrings({state, commit}, culture) {
    return new Promise(resolve => {
      const url = `${AtriumApi}api/resource/allstringsculture?culture=${culture}`;
      axios
        .get(url)
        .then(res => {
          commit("setStrings", res.data);
          resolve();
        })
        .catch(error => {
          console.warn(error);
        });
    })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
